module.exports = __webpack_public_path__ + "384049b54b14d9b5092aa4c30cc2910a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bb-cream/nude-swatch.jpg
 ** module id = 426
 ** module chunks = 0
 **/